import { use } from "react";

export const claudeMandatoryOptions = [
    {
        key: "ClaudeConversations",
        name: "ClaudeConversations",
        title: "Claude conversations",
        description: "All conversations you’ve had in the Claude chatbot.",
        optionPlatform: "claude",
        essential: true,         
        payment: "+$5.0",
        type: "standard",
        parent: null,
        use: null,
        warning: "These conversations may contain sensitive personal information. We strongly recommend checking the archive before donation to better understand what you are donating."
    },

]; 

export const claudeOptionalOptions = [
    {   
        key: "ClaudeProjects", 
        name: "ClaudeProjects",
        title: "Claude projects",
        description: "This is metadata from 'projects' you’ve created in the Claude platform. This includes project details and associated prompt template if any.",
        optionPlatform: "claude",
        essential: false,         
        payment: "+$1.0",
        type: "standard",
        parent: null, 
        use: null,
        warning: "Projects data contains your email address. We remove that field before saving the files in our infrastructure."
    }
]; 

export const claudeExcludedOptions  = [
    {

    }


]; 